import { curry } from 'ramda'

const excludePartsFromLocations = {
  name: 'excludePartsFromLocations',
  rule: curry((__, { panelNumber }, { name }) => {
    const locationHasExclusionRules = ['AU001', 'AU011', 'AU012'].includes(name)
    const componentCanBeExcluded = [
      'ENP168501 00225',
      '22-73304-000',
      'ENP136501 00225',
    ].includes(panelNumber)

    return !(locationHasExclusionRules && componentCanBeExcluded)
  }),
}

export const rules = {
  defaults: [excludePartsFromLocations],
}
